import '@ui5/webcomponents/dist/CustomListItem.js';
import { ListItemType } from '../../enums';
import { withWebComponent } from '../../internal/withWebComponent';
/**
 * A component to be used as custom list item within the `List` the same way as the standard `StandardListItem`. The component accepts arbitrary HTML content to allow full customization
 *
 * <ui5-link href="https://sap.github.io/ui5-webcomponents/playground/components/CustomListItem" target="_blank">UI5 Web Components Playground</ui5-link>
 */
const CustomListItem = withWebComponent('ui5-li-custom', ['accessibleName', 'type'], ['selected'], [], ['detail-click']);
CustomListItem.displayName = 'CustomListItem';
CustomListItem.defaultProps = {
    type: ListItemType.Active
};
export { CustomListItem };
